import React from "react";
import { useNavigate } from "react-router-dom";
import "./Menu.css";
import awlLogo from "./awl-logo.png";

export default function Menu({ onLogout }) {
  const navigate = useNavigate();

  return (
    <div>
      <div className="app-header">
        <h1 className="app-name-header">
          insight<span className="app-name-highlight">360</span>
        </h1>
        <img src={awlLogo} alt="AWL Logo" className="company-logo-header" />
      </div>

      <div className="main-content menu-page">
        <h2 className="page-title">Menu</h2>
        <div className="card menu-card">
          <div className="menu-item" onClick={() => navigate("/profile")}>
            <span className="menu-icon">👤</span>
            <span className="menu-label">My Profile</span>
            <span className="menu-chevron">&gt;</span>
          </div>

          <div className="menu-item">
            <span className="menu-icon">📄</span>
            <span className="menu-label">Terms & Conditions</span>
            <span className="menu-chevron">&gt;</span>
          </div>
        </div>

        <div className="logout-section">
          <button className="logout-btn" onClick={onLogout}>
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
}
